import * as React from "react";
import ModalContext, {ModalContextType} from "./ModalContext";

// NOTE(CK): Adapted from https://react-typescript-cheatsheet.netlify.app/docs/hoc/intro/

export default function withModalContext<T extends ModalContextType = ModalContextType>(
    WrappedComponent: React.ComponentType<T>,
) {
    const ComponentWithTheme = (props: Omit<T, keyof ModalContextType>) => {
        return (
            <ModalContext.Consumer>
                {(context: ModalContextType) => <WrappedComponent {...(props as T)} {...context} />}
            </ModalContext.Consumer>
        );
    };

    const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    ComponentWithTheme.displayName = `withModalContext(${displayName})`;

    return ComponentWithTheme;
}
